import { InjectionToken } from '@angular/core';
import { SdBottomSheetOptions } from '@shared/v2/models';

export const SD_BOTTOM_SHEET_OPTIONS_TOKEN = new InjectionToken<SdBottomSheetOptions<any>>(
  'SD_BOTTOM_SHEET_OPTIONS_TOKEN',
);
